<template>
  <div id="ccDeposit">
    <div class="content_box">
      <div class="inner">
        <div class="contact_title">
          <h2>{{ $t('deposit.default.deposit') }}</h2>
          <p></p>
        </div>
        <div class="box_card_top" v-if="formFlag">
          <div class="form_deposit">
            <h4>{{ $t('deposit.creditOrDebit.header') }}</h4>
            <div class="info_box">
              <p>{{ $t('deposit.method.desc', { method: $t('deposit.creditOrDebit.header') }) }}</p>
              <ul>
                <li>{{ $t('deposit.method.inst1') }}</li>
                <li>{{ $t('deposit.method.credit.inst2') }}</li>
                <li>{{ $t('deposit.method.credit.inst3') }}</li>
                <li>{{ $t('deposit.method.credit.inst4') }}</li>
              </ul>
            </div>
            <div class="img">
              <img src="@/assets/images/channel/visa-mastercard-logo.png" alt />
            </div>
          </div>
        </div>
        <div class="box_card_bottom" v-if="formFlag">
          <div class="form_main">
            <el-form :model="depositForm" ref="depositForm" status-icon :rules="depositRules">
              <ul class="clearfix">
                <li class="fl">
                  <AccountNumber
                    supportedCurrencies="all"
                    @setCurrency="setCurrency"
                    @setAccountNumber="setAccountNumber"
                  ></AccountNumber>
                </li>
                <li class="fr">
                  <numeric-input
                    v-model="depositForm.amount"
                    :currency="accountCurrency"
                    :precision="2"
                    :label="$t('common.field.amt')"
                    name="amount"
                    @blur="onAmountBlur"
                  ></numeric-input>
                </li>
              </ul>
              <ul class="clearfix">
                <li class="fl">
                  <InputForm :label="$t('common.field.imptNotes')" name="applicationNotes" v-model="depositForm.notes">
                  </InputForm>
                </li>
              </ul>
              <DepositDiscount
                v-if="isLoyalty"
                v-bind="depositDiscountProps"
                @setDepositDiscount="setDepositDiscount"
                :discRateChange="discConversionProps"
              />
              <div class="desc_box">
                <ul>
                  <li>{{ $t('transferFunds.depositNote') }}:</li>
                  <li>1. {{ $t('deposit.method.credit.note1') }}</li>
                  <li>
                    <p
                      v-html="
                        // '2. ' + $t('deposit.cc.note', { mail: this.$config.info.getDepositEmail(this.regulator) })
                        '2. ' + $t('deposit.method.credit.note2', { mail: 'info@vtmarkets.com' })
                      "
                    ></p>
                  </li>
                </ul>
              </div>
              <div class="form_button">
                <el-button class="el-button blue_button" :loading="loading" @click="submitForm()" data-testid="submit">
                  {{ $t('common.button.submit') }}
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
        <div id="main"></div>
      </div>
    </div>
  </div>
</template>

<script>
import NumericInput from '@/components/NumericInput';
import AccountNumber from '@/components/form/AccountNumber';
import mixin from '@/mixins/page/deposit';
import { apiBridge_payment, apiQueryRate_USD_JPY } from '@/resource';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';

export default {
  name: 'ccDeposit',
  components: { NumericInput, AccountNumber },
  mixins: [mixin],
  data() {
    const validateAmount = (rule, value, callback) => {
      let minLimit;
      let maxLimit;

      switch (this.accountCurrency) {
        case 'JPY':
          minLimit = 5000;
          maxLimit = this.maxLimit;
          break;
        case 'HKD':
          minLimit = 400;
          maxLimit = 999999999;
          break;
        case 'USD':
          minLimit = this.minLimit;
          maxLimit = 1000000;
          break;
        default:
          minLimit = this.minLimit;
          maxLimit = this.maxLimit;
          break;
      }

      if (value === '' || !Number(value)) {
        callback(new Error(this.$t('common.formValidation.amtReq')));
      } else if (parseFloat(value) < minLimit) {
        callback(
          new Error(this.$t('common.formValidation.amtLarger', { minLimit: minLimit, currency: this.accountCurrency }))
        );
      } else if (parseFloat(value) > maxLimit) {
        callback(
          new Error(this.$t('common.formValidation.amtLess', { maxLimit: maxLimit, currency: this.accountCurrency }))
        );
      } else {
        callback();
      }
    };
    return {
      depositForm: {
        accountNumber: '',
        amount: '',
        notes: ''
      },
      depositRules: {
        accountNumber: [
          {
            required: true,
            message: this.$t('common.formValidation.accReq'),
            trigger: 'change'
          }
        ],
        amount: [
          {
            required: true,
            validator: validateAmount,
            trigger: 'blur'
          }
        ],
        notes: [
          {
            pattern: /^.{0,256}$/,
            message: this.$t('common.formValidation.note256'),
            trigger: 'blur'
          }
        ]
      },
      minLimit: 50,
      rate: 0.0,
      formFlag: true,
      formName: 'depositForm'
    };
  },
  watch: {
    accountCurrency(newValue, oldValue) {
      if (newValue === oldValue) return;

      if (newValue === 'JPY') {
        this.queryRate();
      }
    }
  },
  computed: {
    isJPY() {
      return this.accountCurrency === 'JPY';
    },
    discConversionProps() {
      return this.isJPY
        ? {
            rate: this.rate
          }
        : {};
    }
  },
  methods: {
    setAccountNumber(accountNumber, accountDetail) {
      this.depositForm.accountNumber = accountNumber;
      this.accountDetail = accountDetail;
    },
    submitDeposit() {
      return apiBridge_payment(
        {
          mt4Account: this.depositForm.accountNumber,
          operateAmount: this.depositForm.amount,
          applicationNotes: this.depositForm.notes,
          redemptionCode: this.voucherID
        },
        this.token
      );
    },
    submitForm() {
      this.$refs['depositForm'].validate(valid => {
        if (valid) {
          this.loading = true;
          sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_DETAIL_PAGE_CLICK, {
            account_platform: this.accountDetail.platform,
            account_type: this.accountDetail.accountTypeDisplay,
            account_info: `${this.depositForm.accountNumber}`,
            account_currency: this.accountCurrency,
            deposit_method: SENSORS_TRACK.DEPOSIT_METHOD.CREDIT_CARD,
            button_name: SENSORS_TRACK.BUTTON_NAME.DEPOSIT_PAY_NOW,
            is_coupon: this.voucherID ? 1 : 0,
            coupon_id: this.voucherID ? `${this.voucherID}` : '',
            coupon_name: this.voucherID ? 'Deposit Discount' : '',
            coupon_amount: this.voucherID ? `${this.discountedAmount}` : '',
            coupon_type: this.voucherID ? 'Deposit Discount' : '',
          })
          this.submitDeposit()
            .then(result => {
              if (result.data.data && result.data.code == 0) {
                this.formFlag = false;
                this.showBridgerpay(result.data.data);
              } else {
                this.errorMessage(this.$t('deposit.default.failed'));
                // re-calling anti-reuse token
                this.fetchToken()
                  .then(resp => {
                    this.loading = false;
                  })
                  .catch(resp => {
                    this.loading = false;
                    this.errorMessage(this.$t('deposit.default.failed'));
                  });
              }
            })
            .catch(err => {
              this.loading = false;
              this.errorMessage(this.$t('deposit.default.failed'));
            });
        }
      });
    },
    showBridgerpay(data) {
      const dataJson = JSON.parse(data);
      let script = document.createElement('script');
      script.setAttribute('src', dataJson.url);
      script.setAttribute('data-theme', 'dark');
      script.setAttribute('data-cashier-key', dataJson.key);
      script.setAttribute('data-cashier-token', dataJson.token);
      document.getElementById('main').appendChild(script);
    },
    queryRate() {
      apiQueryRate_USD_JPY()
        .then(resp => {
          if (resp.data.code == 0) this.rate = this.initialRate(resp.data.data);
        })
        .catch(err => {
          this.errorMessage(
            this.$t('deposit.default.rate.result.rateError', {
              oldCurrency: this.accountCurrency ? this.accountCurrency : 'USD',
              newCurrency: 'JPY'
            })
          );
        });
    }
  },
  mounted() {
    sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_DETAIL_PAGE_VIEW);
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/deposit/default.scss';
@import '@/assets/css/variables/_theme.scss';

.desc_box {
  font-size: 16px;
  margin: 40px 0;

  p:not(:last-child) {
    margin-bottom: 20px;
  }

  > ul {
    > li {
      margin-bottom: 15px;
      width: 100% !important;

      &::marker {
        color: $primary-blue;
      }
    }
  }

  a {
    color: #90bbea;
    text-decoration: underline;
  }
}
</style>
